import React from "react";

import { appConstants } from "../../config/app-constants";

type Props = {};

const ExemptAllowancesHint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<section className="text-center">
				<img
					src={`${appConstants.basePath}/assets/images/hints/exempt-allowances.png`}
					alt="exempt allowances"
					className="img-fluid d-block mx-auto my-4"
				/>
			</section>
		</>
	);
};

export default ExemptAllowancesHint;
